/**
 * Csv Schema of SaraivaCnpjDisponivel
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {SaraivaCnpjDisponivel} from '@/model/resource/SaraivaCnpjDisponivel'

/* TODO: review generated schema */
export class CsvSaraivaCnpjDisponivelSchema extends Schema {
  readonly name = 'CsvSaraivaCnpjDisponivel'

  readonly fieldSet: FieldSet<SaraivaCnpjDisponivel> = {
    id: schema => schema.model.id,
    cnpjRaiz: schema => schema.model.cnpjRaiz,
  }
}
